import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const DButton = styled(Button)(({ theme }) => ({
  color: '#fff',
  backgroundImage: theme.custom.gradients.brand,
  borderRadius: '10px',
  textTransform: 'none',
  transition: 'background 1s',
  '&.Mui-disabled': {
    backgroundImage: theme.custom.gradients.brandDisabled,
    color: theme.palette.white.main,
  },
  // Loading also sets Mui-disabled, and a busy action is not an unavailable
  // one: the brand gradient stays and the spinner carries the difference.
  '&.MuiButton-loading': {
    backgroundImage: theme.custom.gradients.brand,
  },
}));

const CustomButton = function CustomButton({
  onClick = () => {},
  label = '',
  startIcon = null,
  endIcon = null,
  styles = {},
  loading = false,
  ...props
}) {
  return (
    <DButton
      id="databeasy-styled-button"
      onClick={onClick}
      startIcon={!endIcon ? startIcon : null}
      endIcon={!startIcon ? endIcon : null}
      loadingIndicator={<CircularProgress size={18} sx={{ color: '#fff' }} />}
      sx={styles}
      loading={loading}
      {...props}
    >
      {label}
    </DButton>
  );
};

export default CustomButton;
